import { Reason } from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChCreatePsychologicalPsychoTherapyMutation.graphql"
import {
  Aim,
  ConditionStage,
  NutritionalCondition,
  ObesityTherapy,
  Occurrence,
  PrescriptionRepetition,
  Side,
  TreatmentUnitPerDay,
} from "@/types/__generated__/union-types"

const REASONS: Array<Reason> = ["SICKNESS", "ACCIDENT", "IVMV"]

const AIMS_OF_TREATMENT: Array<Aim> = [
  "ANALGESIA_ANTI_INFLAMMATORY_TREATMENT",
  "IMPROVEMENT_OF_JOINT_FUNCTION",
  "IMPROVEMENT_OF_MUSCLE_FUNCTION",
  "PROPRIOCEPTION_COORDINATION",
  "IMPROVEMENT_OF_CARDIO_PULMO_FUNCTION",
  "DECONGESTION",
  "IMPROVEMENT_OF_MOBILITY",
  "FUNCTIONAL_BANDAGE_TAPE",
  "INSTRUCTION",
]

const NUTRITIONAL_CONDITIONS: Array<NutritionalCondition> = [
  "OBESITY",
  "METABOLIC_DISEASES",
  "CARDIOVASCULAR_DISEASES",
  "DISEASES_OF_THE_DIGESTIVE_SYSTEM",
  "KIDNEY_DISEASES",
  "MALNUTRITION_AND_MALNOURISHMENT_CONDITIONS",
  "FOOD_ALLERGIES_OR_ALLERGIC_REACTIONS_TO_FOOD_COMPONENTS",
]

const OBESITIES: Array<ObesityTherapy> = ["INDIVIDUAL_THERAPY", "MULTIPROFESSIONAL_STRUCTURED_INDIVIDUAL_THERAPY"]

const PRESCRIPTION_REPETITIONS: Array<PrescriptionRepetition> = ["FIRST", "SECOND", "THIRD", "FOURTH"]

const TREATMENT_UNITS_PER_DAY: Array<TreatmentUnitPerDay> = ["ONCE", "TWICE"]

const OCCURRENCES: Array<Occurrence> = ["FIRST_OCCURRENCE", "RECURRENCE"]

const SIDES: Array<Side> = ["LEFT", "RIGHT"]

const CONDITION_STAGES: Array<ConditionStage> = ["ACUTE", "SUBACUTE", "CHRONIC"]

export {
  REASONS,
  AIMS_OF_TREATMENT,
  PRESCRIPTION_REPETITIONS,
  SIDES,
  CONDITION_STAGES,
  NUTRITIONAL_CONDITIONS,
  OBESITIES,
  TREATMENT_UNITS_PER_DAY,
  OCCURRENCES,
}
